import React from 'react'
import { useNavigate } from 'react-router-dom'

import * as styles from './Property.module.scss'

import { PATH } from '../../../constants'
import { useCreateNextPath } from '../../../hooks'
import { Flex, FlexBox } from '../../basics'
import { PropertyCard } from '../../contents'

type PropertyProps = {
  name?: string
  description?: string
  slug?: string
  images: string[]
  access?: string
  pricing?: string
}

type PropertyListProps = {
  properties: PropertyProps[]
  canNavigate?: boolean
}

const PropertyCardWrapper: React.FC<
  PropertyProps & {
    canNavigate?: boolean
  }
> = ({ name, slug, description, images, access, pricing, canNavigate }) => {
  const navigate = useNavigate()
  const { onCreateNextPath } = useCreateNextPath()

  return (
    <PropertyCard
      title={name ?? ''}
      images={images}
      access={access}
      pricing={pricing}
      canNavigate={canNavigate}
      property={slug}
      showFitScreenIcon
      onClick={() => {
        if (!slug) {
          return
        }
        navigate(
          onCreateNextPath(PATH.property, {
            pathParams: { property: slug },
            queryParams: { page: undefined },
          })
        )
      }}
    >
      <p className={styles.desc}>{description}</p>
    </PropertyCard>
  )
}

export const PropertyList: React.FC<PropertyListProps> = ({
  properties,
  canNavigate,
}) => (
  <Flex optionClass={styles.list}>
    {properties.map(
      ({ slug, name, description, images, access, pricing }) =>
        name &&
        slug && (
          <FlexBox key={slug} optionClass={styles.item}>
            <PropertyCardWrapper
              slug={slug}
              name={name}
              description={description}
              images={images}
              access={access}
              pricing={pricing}
              canNavigate={canNavigate}
            />
          </FlexBox>
        )
    )}
  </Flex>
)
